<script lang="ts">
  import { AppState } from '../../etc/stores';

  const { tertiary } = $AppState.theme.colors.illustration;

  export let stroke: string = tertiary;
  export let size: string | number = 24;
</script>

<svg
  width={size}
  height={size}
  viewBox="0 0 24 24"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M20 6L9 18L4 12.5455"
    {stroke}
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
  />
</svg>
